import dispatch from './';

export default (action, name) =>
	(data = null) => {
		dispatch(action, data, name);
		return data;
	};
